import type { RaasInitConfig } from "./types";

let store: { config: RaasInitConfig } | null = null;

export const setRaasContext = (config: RaasInitConfig): void => {
  store = { config };
};

export const getRaasContextOptional = (): { config: RaasInitConfig } | null =>
  store;

export const getRaasContext = (): { config: RaasInitConfig } => {
  if (!store) {
    throw new Error("[Raas] Call init() before using this API");
  }
  return store;
};
